import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import 'aos/dist/aos.css';
import AOS from 'aos';
import whobanner from "../img/quote.png";

import { FaChartBar, FaBrain, FaBolt, FaRobot, FaCloud, FaLock, FaChartLine, FaHeadset, FaClock, FaComments,FaWhatsapp,  FaUserCheck,FaCogs,} from 'react-icons/fa';

const DataAnalyticsServices = ({ name }) => {
  const videoRef = useRef(null);
  const [openFAQ, setOpenFAQ] = useState(null);
  const [formData, setFormData] = useState({ name: '', email: '', phoneno: '', country_code: '', location: '', industry_type: '', availability: '', type_of_service: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formMessage, setFormMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({ title: '', message: '', status: 'info' });
  const navigate = useNavigate();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const nameRegex = /^[A-Za-z\s]+$/;
const phoneDigitsRegex = /^[0-9]{10}$/;


  const countryCodes = [
    { code: '+91', flag: '🇮🇳', label: 'India' },
    { code: '+1', flag: '🇺🇸', label: 'United States' },
    { code: '+44', flag: '🇬🇧', label: 'United Kingdom' },
    { code: '+61', flag: '🇦🇺', label: 'Australia' },
    { code: '+971', flag: '🇦🇪', label: 'UAE' },
  ];

  const API_BASE = process.env.REACT_APP_API_URL || 'https://api.securxperts.com:8000';

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 900, once: true, easing: 'ease-in-out' });

    const handleScroll = () => {
      if (videoRef.current) {
        const translateY = window.scrollY * 0.25;
        videoRef.current.style.transform = `translateY(${translateY}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [name]);

  const toggleFAQ = (index) => setOpenFAQ(openFAQ === index ? null : index);

const handleInputChange = (e) => {
  const { id, value } = e.target;

  // Name: allow only alphabets & spaces
  if (id === "name") {
    if (!/^[A-Za-z\s]*$/.test(value)) return;
  }

  // Phone: allow only numbers & max 10 digits
  if (id === "phoneno") {
    if (!/^[0-9]*$/.test(value)) return;
    if (value.length > 10) return;
  }

  setFormData(prev => ({ ...prev, [id]: value }));
};


  const handleCountryCodeChange = (e) => setFormData(prev => ({ ...prev, country_code: e.target.value }));

const validateForm = () => {
  const { name, email, phoneno, country_code, location, industry_type, availability, type_of_service } = formData;

  if (!name || !email || !phoneno || !country_code || !location || !industry_type || !availability || !type_of_service) {
    return 'Please fill out all fields.';
  }

  if (!nameRegex.test(name)) {
    return 'Name should contain only alphabets.';
  }

  if (!emailRegex.test(email)) {
    return 'Please enter a valid email address.';
  }

  if (!phoneDigitsRegex.test(phoneno)) {
    return 'Phone number must be exactly 10 digits.';
  }

  return null;
};

  const openModal = (title, message, status = 'info') => { setModalContent({ title, message, status }); setShowModal(true); };
  const closeModal = () => setShowModal(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormMessage('');
    const error = validateForm();
    if (error) { setFormMessage(error); return; }

    setIsSubmitting(true);
    try {
      const payload = { ...formData };
      const response = await fetch(`${API_BASE}/forms/services`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const result = await response.json().catch(() => ({}));
      const success = result && (result.success === true || (result.message && /success/i.test(result.message)));
if (success) {

  openModal(
    'Success',
    'Your form has been submitted successfully.',
    'success'
  );

  setFormData({
    name: '',
    email: '',
    phoneno: '',
    country_code: '+91',
    location: '',
    industry_type: '',
    availability: '',
    type_of_service: '',
  });

  // Keep popup open for 5 seconds
  setTimeout(() => {
    closeModal();
  }, 5000);

} else {
  const msg = result?.message || 'Failed to send request. Please try again later.';
  setFormMessage(msg);
}

    } catch (err) {
      setFormMessage(err?.message || 'Something went wrong. Please try again.');
    } finally { setIsSubmitting(false); }
  };

  const cardStyle = { background: '#ECF0FE', color: '#210A4A' };
  const iconContainerStyle = { background: 'white' };

  return (
    <div className="min-h-screen bg-white font-sans text-base leading-relaxed">
      <Helmet>
        <title>Data Analytics Services in Hyderabad | SecurXpert</title>
        <meta name="description" content="We build AI-powered chatbot solutions using NLP, automation, and cloud technologies to improve customer engagement and business efficiency." />
      </Helmet>

      <Navbar />

      {/* HERO */}
      <header className="relative w-full">
  <div
    className="relative w-full h-[317px] bg-center bg-cover bg-no-repeat"
    style={{ backgroundImage: `url(${whobanner})` }}
  >
    {/* Dark overlay */}
    <div className="absolute inset-0 bg-black/55 lg:bg-black/60" />

    {/* Centered text content */}
    <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-10">
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 drop-shadow-md">
              AI Chatbot Development Services
      </h1>

      <div className="flex items-center gap-2 text-sm sm:text-base">
        <Link to="/" className="hover:underline">Home</Link>
        <svg
          width="7"
          height="10"
          viewBox="0 0 7 10"
          fill="none"
          className="mt-[2px]"
        >
          <path
            d="M0.297 0.262C0.105 0.426 -0.002 0.648 0 0.878C0.002 1.109 0.113 1.329 0.308 1.492L4.02 4.604L0.366 7.711C0.173 7.875 0.067 8.097 0.069 8.328C0.071 8.558 0.182 8.778 0.377 8.941C0.474 9.022 0.59 9.086 0.717 9.13C0.844 9.174 0.981 9.196 1.118 9.195C1.255 9.194 1.391 9.171 1.518 9.126C1.644 9.081 1.758 9.016 1.854 8.933L6.232 5.212C6.329 5.131 6.405 5.034 6.457 4.927C6.509 4.821 6.535 4.706 6.534 4.591C6.533 4.476 6.505 4.362 6.451 4.256C6.397 4.15 6.319 4.054 6.221 3.974L1.774 0.254C1.677 0.173 1.561 0.109 1.434 0.065C1.307 0.021 1.171 -0.001 1.033 0C0.896 0.001 0.76 0.024 0.634 0.069C0.507 0.114 0.393 0.18 0.297 0.262Z"
            fill="white"
          />
        </svg>
        <span> AI Chatbot Development Services </span>
      </div>
    </div>
  </div>
</header>

      {/* SERVICES */}
      <section className="py-10 sm:py-14 md:py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div className="relative w-full">
              <img src="/img/ai.jpg" alt="AI chatbot development illustrating conversational automation and customer interaction" className="w-full h-56 sm:h-64 md:h-80 lg:h-96 object-cover rounded-xl shadow-xl" loading="lazy" />
            </div>
            <div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-4 text-[#210A4A]">      AI Chatbot Development Services </h2>
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-6">Our AI chatbot development services help businesses deliver real-time, personalized, and automated conversations across websites, mobile apps, and messaging platforms. We use advanced natural language processing, machine learning, and cloud-based architectures to build scalable and secure chatbot solutions. These chatbots improve response time, reduce operational costs, and enhance customer satisfaction. Our solutions are tailored to industry-specific needs, ensuring seamless integration with existing systems. With continuous optimization and AI-driven insights, our chatbots support long-term digital growth.</p>
              <Link to="/contact-us" onClick={() => console.log('Book a Free Demo clicked')} className="inline-block px-6 py-3 rounded-full font-semibold text-white bg-[#3E66F3] hover:bg-indigo-900 transition">Book a Free Demo</Link>
            </div>
          </div>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { title: 'Website AI Chatbot Development', icon: <FaComments className="text-3xl" aria-label="Website AI chatbot interacting with customers in real time" />, description: 'We develop intelligent website chatbots that engage visitors in real time, answer queries instantly and guide users toward enquiries, bookings or purchases.' },
              { title: 'WhatsApp Chatbot Development', icon: <FaWhatsapp className="text-3xl" aria-label=" WhatsApp chatbot automation for business communication" />, description: 'Automate customer conversations on WhatsApp with AI-powered chatbots for enquiries, follow-ups, order updates and customer support.' },
              { title: 'Conversational AI Chatbots', icon: <FaBrain className="text-3xl" aria-label=" Conversational AI chatbot using natural language processing" />, description: 'Our conversational AI chatbots use NLP to deliver human-like, context-aware interactions that improve customer experience and engagement.' },
              { title: 'AI Customer Support Chatbots', icon: <FaHeadset className="text-3xl" aria-label=" AI customer support chatbot handling queries automatically"/>, description: 'Reduce support workload by deploying AI chatbots trained on FAQs, documents and knowledge bases to handle routine customer requests 24/7.' },
              { title: 'AI Lead Generation Chatbots', icon: < FaUserCheck className="text-3xl" aria-label="AI lead generation chatbot capturing customer information" />, description: 'Smart chatbots designed to ask relevant questions, qualify prospects and deliver high-quality leads directly to your sales teams.' },
              { title: 'Custom AI Chatbot Solutions', icon: <FaCogs className="text-3xl" aria-label="Custom AI chatbot solution architecture diagram" />, description: 'Tailor-made chatbot development services customized to your business workflows, data and industry-specific requirements.' },
            ].map((service, i) => (
              <article key={i} className="rounded-xl shadow-lg p-6 flex flex-col items-center text-center hover:shadow-2xl transform transition hover:scale-[1.02]" style={cardStyle}>
                <div className="bg-white rounded-full p-3 w-16 h-16 flex items-center justify-center mb-4" style={iconContainerStyle}>{service.icon}</div>
                <h3 className="text-lg font-bold mb-2" style={{ color: cardStyle.color }}>{service.title}</h3>
                <p className="text-sm leading-relaxed text-gray-700">{service.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* TECH STACK */}
 <section className="py-10 bg-[#DBE3FF]">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center mb-6 text-[#210A4A]">
      From Conversations to Intelligent Automation
    </h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {[
        { 
          title: 'Chatbot Strategy & Use Case Discovery', 
          tech: 'We start by understanding your business goals, customer journeys and automation needs to identify high-impact chatbot use cases.',
          icon: <FaCloud className="text-4xl" aria-label="AI chatbot strategy and use case planning" title="Chatbot Strategy & Use Case Discovery" />
        },
        { 
          title: 'Conversation Design & Architecture', 
          tech: 'Our experts design intelligent conversation flows, intents and chatbot architectures aligned with your brand and objectives.',
          icon: <FaCloud className="text-4xl" aria-label="Chatbot conversation flow and architecture design" title="Conversation Design & Architecture" />
        },
        { 
          title: 'AI Training & NLP Optimization', 
          tech: 'Chatbots are trained using your website content, FAQs, documents and datasets to ensure accurate and contextual responses.',
          icon: <FaCloud className="text-4xl" aria-label="NLP training process for AI chatbots" title="AI Training & NLP Optimization" />
        },
        { 
          title: 'Development, Integration & Deployment', 
          tech: 'We develop and deploy AI chatbots across websites and messaging platforms with seamless integration into your systems.',
          icon: <FaCloud className="text-4xl" aria-label="AI chatbot deployment and system integration" title="Development, Integration & Deployment" />
        },
        { 
          title: 'Monitoring, Analytics & Continuous Improvement', 
          tech: 'Ongoing monitoring and optimization improve chatbot performance, accuracy and business outcomes over time.',
          icon: <FaCloud className="text-4xl" aria-label=" Chatbot analytics dashboard showing performance metrics" title="Monitoring, Analytics & Continuous Improvement" />
        },
      ].map((item, i) => (
        <div key={i} className="bg-white rounded-xl shadow-lg p-6 flex flex-col items-center text-center">
          <div className="mb-4">{item.icon}</div>
          <h4 className="text-lg font-bold mb-2 text-[#210A4A]">{item.title}</h4>
          <p className="text-sm text-gray-700">{item.tech}</p>
        </div>
      ))}
    </div>
  </div>
</section>


      {/* METHODOLOGY */}
     <section className="py-10 bg-white">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center mb-8 text-[#210A4A]">
      Our Cutting-Edge Chatbot Technology Stack
    </h2>
    <div className="space-y-6">
      {[
        { 
          title: 'AI & NLP Frameworks', 
          desc: 'Natural Language Processing, Machine Learning, Conversational AI Models.',
          aria: ' AI NLP frameworks powering chatbot intelligence'
        },
        { 
          title: 'Chatbot Platforms & Integrations', 
          desc: 'Website Chat, WhatsApp APIs, CRM & Business System Integrations.',
          aria: 'Chatbot integration with CRM and messaging platforms'
        },
        { 
          title: 'Automation & Analytics', 
          desc: 'Workflow Automation, Conversation Analytics, Performance Dashboards.',
          aria: 'AI chatbot automation and analytics dashboard'
        },
        { 
          title: 'Security & Compliance', 
          desc: 'Data Encryption, Secure APIs, Access Control & Privacy Standards.',
          aria: 'Secure AI chatbot architecture with data encryption'
        },
      ].map((step, i) => (
        <div
          key={i}
          className="bg-white rounded-2xl shadow-lg p-6 sm:p-8"
          aria-label={step.aria}
          title={step.title}
        >
          <h3 className="text-xl font-bold text-[#210A4A]">{step.title}</h3>
          <p className="text-gray-700 mt-2">{step.desc}</p>
        </div>
      ))}
    </div>
  </div>
</section>


      {/* WHY CHOOSE US */}
  <section className="py-10 text-white bg-[#210A4A]">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center mb-8">
      Why Choose SecurXpert for AI Chatbot Development Services?
    </h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
      {[
        { 
          title: 'Human-Like Conversational Intelligence', 
          text: 'We design AI chatbots that communicate naturally, delivering intuitive and engaging user experiences.',
          aria: 'Human-like AI chatbot conversation experience'
        },
        { 
          title: 'Scalable AI Chatbot Solutions', 
          text: 'Our chatbot development services are built to scale effortlessly as your business and customer interactions grow.',
          aria: 'Scalable AI chatbot infrastructure'
        },
        { 
          title: 'Future-Ready AI Architecture', 
          text: 'We design chatbots that are ready for advanced AI enhancements and integrations.',
          aria: 'Future-ready AI chatbot system architecture'
        },
        { 
          title: 'Fast Deployment with Measurable ROI', 
          text: 'Our agile development approach ensures faster launches and clear improvements in efficiency and conversions.',
          aria: 'AI chatbot ROI and performance improvement graph'
        },
      ].map((item, i) => (
        <div
          key={i}
          className="bg-white rounded-xl p-4 flex items-start gap-4 shadow-md"
          aria-label={item.aria}
          title={item.title}
        >
          <div className="text-[#210A4A]" aria-hidden="true">
            <FaChartLine className="text-3xl" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-[#210A4A]">{item.title}</h3>
            <p className="text-gray-700 text-sm">{item.text}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>


      {/* CTA */}
      <section className="py-10 text-center bg-[#DBE3FF]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-4 text-[#210A4A]">Transform Your Business with AI Chatbot Development Services</h2>
          <p className="text-gray-700 mb-6">AI chatbots are transforming the way businesses communicate with customers. At SecurXpert, we help organizations automate conversations, improve customer engagement and drive growth through intelligent AI chatbot development services. Partner with us to deliver faster responses, smarter automation and better digital experiences.</p>
          <Link to="/contact-us" className="inline-block px-8 py-3 rounded-full font-semibold text-white bg-[#210A4A] hover:bg-indigo-900">Book a Free Demo</Link>
        </div>
      </section>

      {/* FAQs */}
      <section className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center mb-8 text-[#210A4A]">FAQs</h2>
                    <p className='text-center'>If your question isn’t listed, please contact our team with details about your request so we can assist you more efficiently.</p>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="space-y-4">
              {[
                { q: 'What are AI chatbot development services?', a: ' AI chatbot development services involve designing and building intelligent chatbots that automate customer interactions using artificial intelligence and NLP.' },
                { q: 'Can AI chatbots integrate with existing systems?', a: ' Yes, our AI chatbots integrate seamlessly with websites, CRMs, WhatsApp and internal business tools.' },
                { q: 'Are AI chatbots suitable for small businesses?', a: ' Yes, AI chatbots help businesses of all sizes automate responses, capture leads and reduce manual effort.' },
                { q: 'How do you ensure chatbot data security?', a: ' We implement secure APIs, encryption and access controls to ensure data privacy and compliance.' },
              ].map((faq, i) => (
                <div key={i} className="border rounded-lg shadow-sm overflow-hidden">
                  <button id={`faq-btn-${i}`} type="button" onClick={() => toggleFAQ(i)} aria-expanded={openFAQ === i} aria-controls={`faq-panel-${i}`} className="w-full flex items-center justify-between px-4 sm:px-6 py-3 bg-white text-left focus:outline-none focus:ring-2 focus:ring-[#210A4A]">
                    <span className="font-semibold">{faq.q}</span>
                    <svg className={`w-5 h-5 transform transition-transform ${openFAQ === i ? 'rotate-180' : 'rotate-0'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7"/></svg>
                  </button>
                  <div id={`faq-panel-${i}`} role="region" aria-labelledby={`faq-btn-${i}`} className={`px-4 sm:px-6 overflow-hidden transition-[max-height,opacity] duration-300 ${openFAQ === i ? 'py-4 opacity-100' : 'py-0 opacity-0'}`} style={{ maxHeight: openFAQ === i ? '400px' : '0' }}>
                    <p className="text-gray-700">{faq.a}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg flex flex-col items-center">
              <img src="/img/needmorehelp.png" alt=" Frequently asked questions about AI chatbot development" className="w-full sm:w-3/4 h-48 object-cover rounded-lg mb-4" />
              <h3 className="text-xl font-bold text-[#210A4A]">Need more help?</h3>
              <p className="text-gray-600 text-center mt-2">If your question isn’t listed, please contact our team with details about your request so we can assist you more efficiently.</p>
              <Link to="/contact-us" onClick={() => console.log('Contact Us from FAQ')} className="mt-4 inline-block px-6 py-3 rounded-full bg-[#3E66F3] text-white font-semibold hover:bg-indigo-700">Contact Support</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Contact / Quote Form */}
      <section className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div className="space-y-6">
              <h2 className="text-2xl sm:text-3xl font-extrabold text-[#210A4A]">Request a <span className="text-[#3E66F3]">Call Back</span></h2>
              <p className="text-gray-700">Get a free consultation on analytics strategy, real-time pipelines or AI-powered insights.</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex items-center gap-4 bg-white p-4 rounded-lg shadow-md">
                  <div className="p-3 rounded-full bg-[#ECF0FE] text-[#3E66F3]"><FaHeadset className="text-2xl" /></div>
                  <span className="text-gray-700 font-medium">Reply within 24 hours</span>
                </div>
                <div className="flex items-center gap-4 bg-white p-4 rounded-lg shadow-md">
                  <div className="p-3 rounded-full bg-[#ECF0FE] text-[#3E66F3]"><FaClock className="text-2xl" /></div>
                  <span className="text-gray-700 font-medium">24/7 Support</span>
                </div>
              </div>
              <div className="mt-6 text-center lg:text-left">
                <div className="inline-flex items-center justify-center text-white p-6 rounded-full w-28 h-28 shadow-lg bg-[#3E66F3]">
                  <FaHeadset className="text-3xl" />
                </div>
                <h5 className="text-gray-700 mt-4">Call us anytime</h5>
                <h3 className="text-gray-800 font-bold">+91 79932 56679</h3>
              </div>
            </div>

            <div className="bg-white border border-gray-100 rounded-xl shadow-xl p-6 sm:p-8">
              <form onSubmit={handleSubmit} noValidate className="space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="sm:col-span-2">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Full name <span className="text-red-500">*</span></label>
                    <input id="name" type="text" placeholder="e.g., John Doe" value={formData.name} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]" required />
                  </div>

                  <div className="sm:col-span-2">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email address <span className="text-red-500">*</span></label>
                    <input id="email" type="email" placeholder="you@example.com" value={formData.email} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]" inputMode="email" required />
                  </div>

                  <div className="sm:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Phone number <span className="text-red-500">*</span></label>
                    <div className="flex gap-3 flex-col sm:flex-row">
                     <select
  id="country_code"
  value={formData.country_code}
  onChange={handleCountryCodeChange}
  className="border border-gray-300 rounded-lg px-3 py-3 bg-white w-full sm:w-44"
  aria-label="Country code"
  required
>
  <option value="" disabled>
    Select country code
  </option>

  {countryCodes.map((c, idx) => (
    <option key={idx} value={c.code}>
      {`${c.flag} ${c.code} (${c.label})`}
    </option>
  ))}
</select>


                      <input id="phoneno" type="tel" placeholder="1234567890" value={formData.phoneno} onChange={handleInputChange} className="flex-1 border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3] w-full" inputMode="numeric" pattern="[0-9]*" aria-describedby="phone-help" required />
                    </div>
                    {/* <p id="phone-help" className="text-xs text-gray-500 mt-2">Digits only (7–15). Country code selected separately.</p> */}
                  </div>

                  <div>
                    <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-1">Location <span className="text-red-500">*</span></label>
                    <input id="location" type="text" placeholder="City, State or Country" value={formData.location} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]" required />
                  </div>

                  <div>
                    <label htmlFor="industry_type" className="block text-sm font-medium text-gray-700 mb-1">Industry type <span className="text-red-500">*</span></label>
                    <select id="industry_type" value={formData.industry_type} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]" required>
                      <option value="" disabled>Select Industry Type</option>
                      <option>Finance</option>
                      <option>Healthcare</option>
                      <option>Retail</option>
                      <option>Education</option>
                      <option>Manufacturing</option>
                      <option>Other</option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="availability" className="block text-sm font-medium text-gray-700 mb-1">Availability <span className="text-red-500">*</span></label>
                    <select id="availability" value={formData.availability} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]" required>
                      <option value="" disabled>Availability</option>
                      <option>Immediate</option>
                      <option>1-2 weeks</option>
                      <option>1 month+</option>
                    </select>
                  </div>

                  <div className="sm:col-span-2">
                    <label htmlFor="type_of_service" className="block text-sm font-medium text-gray-700 mb-1">Type of service <span className="text-red-500">*</span></label>
                    <select id="type_of_service" value={formData.type_of_service} onChange={handleInputChange} className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#3E66F3]" required>
                      <option value="" disabled>Select Type of Service</option>
                      <option>Business Intelligence & Visualisation</option>
                      <option>Predictive Analytics</option>
                      <option>Real-Time Data Engineering</option>
                      <option>Intelligent Workflow Automation</option>
                      <option>Conversational AI</option>
                    </select>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <button type="submit" disabled={isSubmitting} className="w-full text-white font-semibold py-3 rounded-lg text-lg bg-[#210A4A] disabled:opacity-60 hover:bg-indigo-900">{isSubmitting ? 'Sending...' : 'Send Message'}</button>
                </div>

                {formMessage && <div className={`text-center font-medium ${formMessage.toLowerCase().includes('success') ? 'text-green-600' : 'text-red-600'}`}>{formMessage}</div>}
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* SUCCESS POPUP (PRODUCT PAGE STYLE) */}
      {showModal && (modalContent.status === 'success' || modalContent.status === 'Success') && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-xs w-full shadow-2xl relative p-4 animate-in fade-in zoom-in duration-200">
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl font-bold p-1 hover:bg-gray-100 rounded-full transition-all w-8 h-8 flex items-center justify-center"
            >
              ×
            </button>
            <div className="text-center pt-2">
              <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-green-600 mb-1">Success!</h3>
              <p className="text-gray-600 text-sm">{modalContent.message}</p>
            </div>
          </div>
        </div>
      )}

      {/* REGULAR MODAL FOR ERROR/INFO */}
      {showModal && modalContent.status !== 'success' && modalContent.status !== 'Success' && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 py-6" role="dialog" aria-modal="true" aria-labelledby="modal-title">
          <div className="absolute inset-0 bg-black opacity-40" onClick={closeModal} />
          <div className="relative bg-white rounded-lg shadow-xl max-w-lg w-full p-6 z-10">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-700">i</div>
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold" id="modal-title">{modalContent.title}</h3>
                <p className="mt-2 text-sm text-gray-700">{modalContent.message}</p>
              </div>
              <button onClick={closeModal} aria-label="Close dialog" className="ml-4 text-gray-500 hover:text-gray-700">✕</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DataAnalyticsServices;
